import { useEffect, useMemo, useRef } from 'react';
import { dbPower, spectrogramPixels } from './spectrogramColor';
import { useCanvasSize } from './useCanvasSize';

export function SpectrogramCanvas({ data, length }: { data: any; length: number }) {
  const viewport = useRef<HTMLDivElement>(null), canvas = useRef<HTMLCanvasElement>(null);
  const size = useCanvasSize(viewport, 400);
  const frames: number[][] = data.spectrogram.frames;
  const powers = useMemo(() => frames.map(frame => frame.map(dbPower)), [frames]);
  // Frame centres start at source sample zero; zero-padding covers both source edges.
  const lastFrame = data.spectrogram.hopSamples ? length / data.spectrogram.hopSamples : frames.length - 1;
  useEffect(() => {
    const node = canvas.current; if (!node) return;
    const context = node.getContext('2d'); if (!context) return;
    context.imageSmoothingEnabled = false;
    const image = context.createImageData(size.width, size.height);
    image.data.set(spectrogramPixels(powers, size.width, size.height, lastFrame));
    context.putImageData(image, 0, 0);
  }, [powers, size, lastFrame]);
  return <div className="spectrogram">
    <div className="spectrogram-frequency-axis"><span>{data.sampleRate / 2} Hz</span><span>{data.sampleRate / 4} Hz</span><span>0 Hz</span></div>
    <div ref={viewport} className="spectrogram-viewport"><canvas ref={canvas} width={size.width} height={size.height} role="img"
      aria-label={`Modern spectrogram: ${frames.length} time bins, ${frames[0].length} frequency bins, −100 to 0 dBFS`} /></div>
    <div className="spectrogram-time-axis"><span>0 s</span><span>{(length / data.sampleRate / 2).toFixed(3)} s</span><span>{(length / data.sampleRate).toFixed(3)} s · Time</span></div>
    <div className="spectrogram-legend"><span>−100 dBFS</span><div /><span>0 dBFS</span></div>
    <p className="microcopy">Modern Hann STFT · {data.spectrogram.fftSize ?? 512} samples · hop {data.spectrogram.hopSamples ?? 64} · fixed amplitude scale · no DC removal</p>
  </div>;
}
